// Plays a short notification sound. Asset is bundled under
// /public/sounds/notification.mp3. Respects prefers-reduced-motion
// and per-user `notification_preferences.sound_enabled` (the caller
// passes the boolean — we don't fetch here to keep the helper sync).

const SOUND_URL = '/sounds/notification.mp3'

let cached: HTMLAudioElement | null = null

function preferReducedMotion(): boolean {
  if (typeof window === 'undefined') return false
  return window.matchMedia?.('(prefers-reduced-motion: reduce)')?.matches ?? false
}

function getAudio(): HTMLAudioElement | null {
  if (typeof window === 'undefined') return null
  if (cached) return cached
  try {
    const a = new Audio(SOUND_URL)
    a.preload = 'auto'
    a.volume = 0.45
    cached = a
    return a
  } catch {
    return null
  }
}

export function playNotificationSound(enabled: boolean = true): void {
  if (!enabled) return
  if (preferReducedMotion()) return
  const a = getAudio()
  if (!a) return
  try {
    // Rewind so back-to-back triggers re-play.
    a.currentTime = 0
    void a.play().catch(() => {
      // Browser autoplay restriction: user has not interacted yet.
      // We silently swallow so this never throws.
    })
  } catch {
    // ignore
  }
}
